module.exports = __webpack_public_path__ + "static/media/promenade-classique.ea66810e.jpg";